import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ItemsCarousel from 'react-items-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { envAtom, storeAtom } from '../../../../atoms/Atoms';
import Card from '../../Card';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import Placeholder from './Placeholder';
import api from '../../../../api/api';

function BoughtTogether({ product }) {
  const { t } = useTranslation();
  const env = useRecoilValue(envAtom);
  const store = useRecoilValue(storeAtom);
  const [products, setProducts] = useState([]);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    if (product) {
      api.get(`businesses/${product}/boughttogether`)
      .then(
        (response) => {
          if (response.data.data) {
            setProducts(response.data.data.results);
          }
        },
        (error) => {
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            console.log(error);
          } else {
            console.log(error);
          }
        }
      );
    }
  }, [product]);

  return (
    <div className={`${products?.length > 0 ? 'mt-2' : 'hidden'}`}>
      <div className="text-lg md:text-xl text-secondary font-extrabold tracking-tight">
        {t('frequently_bought_together')}
      </div>
      <ItemsCarousel
        placeholderItem={<Placeholder />}
        enablePlaceholder
        numberOfPlaceholderItems={5}
        infiniteLoop
        gutter={12}
        activePosition="left"
        showSlither
        firstAndLastGutter
        activeItemIndex={activeItemIndex}
        requestToChangeActive={setActiveItemIndex}
        numberOfCards={breakpoint <= 2 ? 1 : 2}
        slidesToScroll={breakpoint <= 2 ? 1 : 2}
        rightChevron={
          <button
            type="button"
            className="flex items-center justify-center h-10 w-10 text-white bg-accent shadow rounded-full"
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        }
        leftChevron={
          <button
            type="button"
            className="flex items-center justify-center h-10 w-10 text-white bg-accent shadow rounded-full"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        }
        classes={{
          itemsWrapper: 'w-full py-2',
          itemWrapper: 'w-full',
        }}
      >
        {_.map(products, (e) => (
          <Card
            key={e.id}
            product={e}
            name={e.name}
            description={e.description}
            image={(e.images.length > 0 && e.images[0].thumbnailUrl) || null}
            id={e.id}
            small
            brand={e.brand}
            price={e.activePrice}
          />
        ))}
      </ItemsCarousel>
    </div>
  );
}

export default BoughtTogether;
